import { useParams } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { FormEditTeamData } from '../../useTeamsDetailsPageController'
import { useToast } from '../../../../../components/ui/use-toast'
import { teamsService } from '../../../../../../app/services/teamsService'
import { UpdateTeamdata } from '../../../../../../app/services/teamsService/updateTeam'
import { useState } from 'react'
import { Goal } from '@/app/entities/Team'

export const useEditTeamDetailsController = () => {
  const { id } = useParams()
  const methods = useFormContext<FormEditTeamData>()
  const [open, setOpen] = useState(false)
  const queryClient = useQueryClient()

  const { toast } = useToast()

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['updateTeam'],
    mutationFn: async ({ data, id }: { data: UpdateTeamdata; id: string }) => {
      return teamsService.updateTeam(data, id)
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['teamId', id],
      })
      queryClient.resetQueries({
        queryKey: ['Allteams', {}],
      })
    },
  })

  const handleEditTeamSubmit = async (data: FormEditTeamData) => {
    try {
      if (id) {
        const updateData: UpdateTeamdata = {
          ...data,
          goals: data.goals
            ? (Object.fromEntries(
                Object.entries(data.goals).filter(
                  ([_, value]) => value !== undefined,
                ),
              ) as { [key: string]: Goal[] })
            : undefined,
        }

        const response = await mutateAsync({ data: updateData, id })

        if (response.name === data.name) {
          toast({
            title: 'Dados atualizados com sucesso!',
          })
        }
        setOpen(false)
      }
    } catch (error) {
      console.log(error)
      toast({
        variant: 'destructive',
        title:
          'Ocorreu um erro ao tentar atualizar os dados, tente novamente mais tarde.',
      })
    }
  }

  return {
    methods,
    isPending,
    handleEditTeamSubmit,
    open,
    setOpen,
  }
}
